module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921061149_T.dcf70a2a.jpg";